export default __webpack_public_path__ + "static/media/Exchange for Light mode.300d09bb.svg";